// "Trusted by pharma leaders" marquee — infinite horizontal scroll of function
// keywords / role families that the agency serves.
// Uses `.animate-marquee` from index.css.
import { useSiteSettings } from "@/lib/settings";

const FALLBACK_KEYWORDS = [
  "Pharmaceutical", "Biotechnology", "Medical Devices", "Clinical Research",
  "Formulation R&D", "Regulatory Affairs", "Pharmacovigilance", "Quality Assurance",
  "GMP Manufacturing", "API / Generics", "Sales & Marketing", "Medical Affairs",
  "CRO / CDMO", "Life Sciences",
];

const Item = ({ label }) => (
  <div className="flex items-center gap-4 px-6">
    <span className="inline-block h-1.5 w-1.5 rounded-full bg-secondary" />
    <span className="whitespace-nowrap font-heading text-sm font-semibold uppercase tracking-widest text-slate-500">
      {label}
    </span>
  </div>
);

export default function TrustedByStrip() {
  const { settings } = useSiteSettings();
  const configured = Array.isArray(settings?.marquee_keywords) ? settings.marquee_keywords.filter(Boolean) : [];
  const keywords = configured.length ? configured : FALLBACK_KEYWORDS;
  return (
    <section
      className="relative overflow-hidden border-y border-slate-200 bg-white py-5"
      data-testid="trusted-by-strip"
      aria-label="Sectors we recruit for"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />
      <div className="flex w-max animate-marquee">
        {[...keywords, ...keywords].map((k, i) => (
          <Item key={`${k}-${i}`} label={k} />
        ))}
      </div>
    </section>
  );
}
